// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3yqQ4","requiredAsterisk":"Info_requiredAsterisk__12ltl"};